<div>Menu Feature: Slider</div>

<ng-template #slideTemplate let-slide="slide" let-i="index">
  <div class="row slider-row">
    <label class="col-2 col-form-label">Headline</label>
    <div class="col-10">
      <app-button-input
        type="text"
        [initialValue]="slide.headline"
        [(value)]="slide.newHeadline"
        [disabled]="slide.newHeadline == slide.headline"
        (apply)="change('headline', i, slide.newHeadline)"
        (cancel)="change('headline', i, slide.headline)"
      ></app-button-input>
    </div>
  </div>

  <div class="row slider-row">
    <label class="col-2 col-form-label">Text</label>
    <div class="col-10">
      <app-button-input
        type="custom"
        [initialValue]="slide.text"
        [(value)]="slide.newText"
        [disabled]="slide.newText == slide.text"
        (apply)="change('text', i, slide.newText)"
        (cancel)="change('text', i, slide.text)"
      >
        <textarea class="form-control" type="text" [placeholder]="slide.text" [(ngModel)]="slide.newText"></textarea>
      </app-button-input>
    </div>
  </div>

  <div class="row slider-row">
    <label class="col-2 col-form-label">Link</label>
    <div class="col-10">
      <div class="btn-group" role="group">
        <input
          type="radio"
          class="btn-check"
          [name]="'link-internal-'+i"
          [id]="'link-internal-'+i"
          autocomplete="off"
          [ngModel]="slide.externalLink"
          [value]="false"
          (change)="changeLinkDestionation(i, false)"
        />
        <label class="btn btn-outline-primary" [for]="'link-internal-'+i"> <fa-icon [icon]="['fal', 'home']"></fa-icon> internal </label>

        <input
          type="radio"
          class="btn-check"
          [name]="'link-external-'+i"
          [id]="'link-external-'+i"
          autocomplete="off"
          [ngModel]="slide.externalLink"
          [value]="true"
          (change)="changeLinkDestionation(i, true)"
        />
        <label class="btn btn-outline-primary" [for]="'link-external-'+i"> <fa-icon [icon]="['fal', 'router']"></fa-icon> external </label>
      </div>
    </div>

    <div class="col-10 offset-2 mt-2">
      <app-button-input
        type="text"
        [initialValue]="slide.link"
        [(value)]="slide.newLink"
        [disabled]="slide.newLink == slide.link"
        (apply)="changeLink(i, slide.newLink)"
        (cancel)="changeLink(i, slide.link)"
      ></app-button-input>
    </div>

    <div class="col-10 offset-2" style="display: flex; align-items: center; color: #8e1600">{{slide.linkError}}</div>
  </div>

  <div class="row slider-row mt-3">
    <label class="col-2 col-form-label">Image</label>
    <div class="col-10">
      <div class="btn-group" role="group">
        <input
          type="radio"
          class="btn-check"
          [name]="'image-anchor-top-'+i"
          [id]="'image-anchor-top-'+i"
          autocomplete="off"
          [ngModel]="slide.imageAnchor"
          value="top"
          (change)="anchor(i, 'top')"
        />
        <label class="btn btn-outline-primary" [for]="'image-anchor-top-'+i">
          <fa-icon [icon]="['fal', 'arrow-from-top']"></fa-icon>
        </label>

        <input
          type="radio"
          class="btn-check"
          [name]="'image-anchor-center-'+i"
          [id]="'image-anchor-center-'+i"
          autocomplete="off"
          [ngModel]="slide.imageAnchor"
          value="center"
          (change)="anchor(i, 'center')"
        />
        <label class="btn btn-outline-primary" [for]="'image-anchor-center-'+i">
          <fa-icon [icon]="['fal', 'arrows-v']"></fa-icon>
        </label>

        <input
          type="radio"
          class="btn-check"
          [name]="'image-anchor-bottom-'+i"
          [id]="'image-anchor-bottom-'+i"
          autocomplete="off"
          [ngModel]="slide.imageAnchor"
          value="bottom"
          (change)="anchor(i, 'bottom')"
        />
        <label class="btn btn-outline-primary" [for]="'image-anchor-bottom-'+i">
          <fa-icon [icon]="['fal', 'arrow-from-bottom']"></fa-icon>
        </label>
      </div>
    </div>
  </div>

  <div class="row slider-row">
    <div class="col-10 offset-2">
      <div class="image-preview">
        <img *ngIf="slide.imageUrl" [src]="slide.imageUrl" />
        <div class="overlay" (click)="selectImage(i)">
          <span class="overlay-icon">
            <fa-icon [icon]="slide.imageUrl ? ['fal', 'pen'] : ['fal', 'image']"></fa-icon>
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="row slider-row">
    <div class="col-10 offset-2">
      <div class="btn-group" role="group">
        <button [disabled]="i == 0" class="btn btn-default" (click)="changePosition(i, -1)">
          <fa-icon [icon]="['fal', 'arrow-up']"></fa-icon>
        </button>
        <button [disabled]="i == slides.length - 1" class="btn btn-default" (click)="changePosition(i, 1)">
          <fa-icon [icon]="['fal', 'arrow-down']"></fa-icon>
        </button>
        <button class="btn btn-danger" (click)="deleteSlide(i)">
          <fa-icon [icon]="['fal', 'trash']"></fa-icon>
        </button>
      </div>
    </div>
  </div>
</ng-template>

<div *ngFor="let slide of slides; let i = index" class="slide">
  <ng-container *ngTemplateOutlet="slideTemplate; context:{slide: slide, index: i}"></ng-container>
</div>

<div class="input-selector-button">
  <button class="btn btn-primary" (click)="addNewSlide()">
    <fa-icon [icon]="['fal', 'plus']"></fa-icon>
  </button>
</div>
